import { Add, ExpandLess, ExpandMore } from "@material-ui/icons";
import {
  Box,
  Card,
  CardContent,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";
import {
  ModalError,
  ModalSuccess,
  PrimaryButton,
  StatusChip,
  SwitchInput,
} from "components";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";
import PeriodSubscriptionItem from "./PeriodSubscriptionItem";
const DropdownDSPSettings = ({ item, onChange }) => {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [open, setOpen] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [formState, setFormState] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [loadingDelete, setloadingDelete] = useState(false);
  const [loadingCheckbox, setloadingCheckbox] = useState(false);

  const { name, is_active_flag, dsp_id } = item || {};
  const activeAllPeriods =
    is_active_flag &&
    (periods?.length === 0 || periods?.every(item => !item?.is_active_flag));

  const addPeriod = () => {
    setFormState(true);
    setPeriods(prev => [...prev, { start_date: null, end_date: null }]);
  };
  const deletePeriod = (item, index) => {
    if (item?.id) {
      handleDeletePeriod(item?.id);
    } else {
      setPeriods(prev => prev.filter((_, idx) => idx !== index));
      setFormState(false);
    }
  };
  const handleChangeStartDate = (date, index) => {
    setPeriods(prev => {
      const newPeriods = [...prev];
      newPeriods[index] = {
        ...newPeriods[index],
        start_date: date,
      };
      return newPeriods;
    });
  };
  const handleChangeEndDate = (date, index) => {
    setPeriods(prev => {
      const newPeriods = [...prev];
      newPeriods[index] = {
        ...newPeriods[index],
        end_date: date,
      };
      return newPeriods;
    });
  };

  const getPeriodsList = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/${id}/dsp-period?dsp_id=${dsp_id}`,
        { headers }
      );
      setPeriods(res?.data?.data || []);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmitPeriod = async item => {
    const formatPayloadMonthYear = date => moment(date).format("YYYY-MM");
    const payload = {
      dsp_id,
      start_date: formatPayloadMonthYear(item?.start_date),
      end_date: formatPayloadMonthYear(item?.end_date),
    };
    try {
      setloadingSubmit(true);
      await axios.post(`${hardBaseUrl}/publisher/${id}/dsp-period`, payload, {
        headers,
      });
      ModalSuccess("Successfully add new period").then(() => {
        getPeriodsList();
        setFormState(false);
      });
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setloadingSubmit(false);
    }
  };
  const handleDeletePeriod = async period_id => {
    try {
      setloadingDelete(true);
      await axios.delete(
        `${hardBaseUrl}/publisher/${id}/dsp-period/${period_id}`,
        { headers }
      );
      ModalSuccess("Successfully delete period").then(() => getPeriodsList());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setloadingDelete(false);
    }
  };
  const handleToggle = async (_, option) => {
    try {
      setloadingCheckbox(true);
      await axios
        .put(
          `${hardBaseUrl}/publisher/${id}/dsp-period/${option?.id}/toggle-status`,
          {},
          { headers }
        )
        .then(() => getPeriodsList());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setloadingCheckbox(false);
    }
  };
  const handleBulkToggle = async e => {
    const { checked } = e?.target;
    onChange(e);
    try {
      setLoadingPage(true);
      await axios
        .put(
          `${hardBaseUrl}/publisher/${id}/dsp-period/bulk-status`,
          { dsp_id, status: checked ? "active" : "inactive" },
          { headers }
        )
        .then(() => getPeriodsList());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    if (open) {
      getPeriodsList();
    }
  }, [open]);

  return (
    <Card>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        p="8px 16px"
      >
        <Grid item>
          <Typography fontWeight={600}>{name}</Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Grid item>
              <SwitchInput
                checked={is_active_flag}
                onChange={handleBulkToggle}
              />
            </Grid>
            <Grid item>
              <IconButton onClick={() => setOpen(o => !o)}>
                {open ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {loadingPage ? (
        <Skeleton variant="rounded" height={160} animation="wave" />
      ) : (
        <Collapse in={open} sx={{ bgcolor: "#F6F6F8" }}>
          <Divider />
          <CardContent>
            <Grid container columnGap={1} alignItems="center">
              <Grid item>
                <Typography fontSize="14px" fontWeight={500}>
                  Period Subscriptions :
                </Typography>
              </Grid>
              {activeAllPeriods && (
                <Grid item>
                  <StatusChip label="Active - All Periods" type="success" />
                </Grid>
              )}
            </Grid>
            <Stack spacing={1} my={2}>
              {periods.map((period, index) => (
                <PeriodSubscriptionItem
                  key={index}
                  disabled={!is_active_flag}
                  onDelete={() => deletePeriod(period, index)}
                  startDate={period?.start_date}
                  endDate={period?.end_date}
                  status={period?.is_active_flag}
                  handleChangeEndDate={date => handleChangeEndDate(date, index)}
                  handleChangeStartDate={date =>
                    handleChangeStartDate(date, index)
                  }
                  handleSubmit={() => handleSubmitPeriod(period)}
                  loadingSubmit={loadingSubmit}
                  loadingDelete={loadingDelete}
                  handleToggle={e => handleToggle(e, period)}
                  loadingCheckbox={loadingCheckbox}
                  periodId={period?.id}
                />
              ))}
            </Stack>
            <PrimaryButton
              label="Add Period"
              startIcon={<Add />}
              disabled={!is_active_flag || formState}
              onClick={addPeriod}
            />
            <Box mt={1}>
              <Typography variant="caption" color="text.secondary">
                DSP remains enabled for selected periods to allow report access
                and CCID generation
              </Typography>
            </Box>
          </CardContent>
        </Collapse>
      )}
    </Card>
  );
};

export default DropdownDSPSettings;
